<template>
  <b-container fluid>
    <b-col lg="12">
      <b-button-group v-show="isShowBtnGroup">
        <b-button :variant="$route.name === 'user-manage.list' ? 'primary' : 'secondary'" class="mb-3" @click="$router.push({name:'user-manage.list'})">
          <i class="las la-address-book"></i>Danh sách thành viên
        </b-button>
        <b-button :variant="$route.name === 'user-manage.add' ? 'primary' : 'secondary'" class="mb-3" @click="$router.push({name:'user-manage.add'})">
          <i class="las la-plus-circle"/> Thêm thành viên
        </b-button>
      </b-button-group>

      <b-button-group v-show="!isShowBtnGroup">
        <b-button :variant="'primary'" class="btn mt-3 mb-3" @click="$router.go(-1)">
            <i class="las la-address-book"/> Danh sách thành viên
        </b-button>
      </b-button-group>
    </b-col>
    <b-col lg="12" class="mx-0 px-0">
      <router-view/>
    </b-col>
  </b-container>
</template>
<script>

export default {
  name: 'UserView',
  computed: {
    isShowBtnGroup () {
      return this.showGroupBtnOn.indexOf(this.$route.name) > -1
    }
  },
  data () {
    return {
      showGroupBtnOn: [
        'user-manage.list',
        'user-manage.add'
      ]
    }
  }
}
</script>
